export const COMMON_SERVICE_URL = "http://localhost:8080/v3biomed"

export const LOGIN_URL = "/authenticateservice/authenticate";
export const LOGOUT_URL = "/authenticateservice/logout";
export const CHECK_AUTHENTICATION_URL = "/authenticateservice/checkAuthentication";
export const CHECK_VERSION_URL = "/commonservice/checkVersion";
export const RE_ACCESS_TOKEN_URL = "/authenticateservice/renewAccessToken";
export const FETCH_ALL_CODE_TABLES_VALUES_URL = "/codetableservice/getAllCodeTableValue";
export const FETCH_OUTSIDE_URL_LIST = "/codetableservice/getOutsideUrlListFromCodeTable";
export const FETCH_CODE_TABLE_VALUES_BY_TABLE_NAME_URL = "/codetableservice/getAllCodeTableValueByTableName";
export const CREATE_PRACTICE_URL = "/practiceservice/createPractice";
export const FETCH_PRACTICES_URL = "/practiceservice/getPracticeList";
export const FETCH_PRACTICE_URL = "/practiceservice/getPracticeById";
export const FETCH_PRACTICES_BY_IDS_URL = "/practiceservice/getPracticesByIds";
export const SAVE_PRACTICE_URL = "/practiceservice/submitPractice";
export const SUBMIT_PRACTICE_URL = "/practiceservice/submitPractice";
export const EDIT_PRACTICE_URL = "/practiceservice/editPractice";
export const SAVE_PRACTICE_PHARMACY_CONFIG_URL = "/practiceservice/savePracticePharmacyConfig"; // CS-2075
export const ADD_PRACTICE_AUTHORIZED_SIGNER = "/practiceservice/addAuthorizedSigners";
export const FETCH_WOUNDCAREINFO_URL = "/codetableservice/codetable";
export const APPROVE_PRACTICE_REQUEST_URL = "/practiceservice/approvePracticeRequest";
export const FETCH_PRACTICE_LOCATIONS_URL = "/practiceservice/getPracticeLocationList";
export const FETCH_PRACTICE_PROVIDERS_URL = "/practiceservice/getPracticeProviderList";
export const FETCH_ALL_PROVIDER_USED_PRACTICE_IDS_URL = "/practiceservice/getAllProviderUsedPracticeIDs";
export const FETCH_PRACTICE_PROVIDER_BY_ID = "/practiceservice/getPracticeProviderById";
export const FETCH_PRACTICE_PRODUCTS_URL = "/practiceservice/getPracticeProductList";
export const CREATE_PRACTICE_AND_ACCOUNT_URL = "/practiceservice/createPracticeAndAccount";
export const VALIDATE_PRACTICE_DETAILS_URL = "/practiceservice/validatePracticeDetails";
export const VERIFY_NPI = "/practiceservice/verifyNpi";
export const COMPLETE_PRACTICE_REGISTRATION = "/practiceservice/completePracticeRegistration";
//CS-1395 - Phase 2 - Start
export const FETCH_PRACTICE_USERS_URL = "/practiceservice/getPracticeUsers";
export const FETCH_ALL_AUTHORIZED_PROVIDER_USERS_URL = "/practiceservice/getAuthorizedProviderUserForPractice";
export const ADD_AUTHORIZED_PROVIDER_USERS_URL = "/practiceservice/addAuthorizedProviderUser";
export const DELETE_AUTHORIZED_PROVIDER_USERS_URL = "/practiceservice/deleteAuthorizedProviderUser";
export const EDIT_AUTHORIZED_PROVIDER_USERS_URL = "/practiceservice/editAuthorizedProviderUser";
//CS-1395 - end

//CS-1732 - Start
export const GET_PRACTICE_LOOK_UP_BY_USER_ROLE_URL="/practiceservice/getPracticeLookupByUserRole"
export const GET_PATIENT_LOOKUP_BY_USER_ROLE_URL="/patientservice/patient/getPatientLookupByUserRole"
//
//CS-1310 - Start (Practice template related URL)
export const FETCH_PRACTICE_TEMPLATES_URL = "/practiceservice/getPracticeTemplates";
export const GET_TEMPLATE_BY_TYPE_URL = "/documentservice/getTemplateByType";
export const ADD_PRACTICE_TEMPLATE_URL = "/documentservice/addPracticeTemplate";
export const GET_MANUFACTURER_TEMPLATES_URL = "/manufacturerService/getManufacturerTemplates";
export const INACTIVE_PRACTICE_TEMPLATE_URL = "/documentservice/inactivatePracticeTemplate";
//CS-1310 - End
export const GET_AUDIT_LOGS_FOR_PRACTICE_DOS_PREFERENCE_URL = "/practiceservice/getAuditLogsForPracticeDOSPreference";
//
export const FETCH_PERMISSIONS_BY_USER_TYPE_URL = "/permissionservice/getPermissionsByUserType";
export const SAVE_PERMISSIONS_BY_USER_TYPE_URL = "/permissionservice/savePermissionsByUserType";

export const FETCH_PRACTICE_PRODUCTS_BY_MFR_URL = "/productservice/practiceproduct/getPracticeProductListByMfr";
//
export const FETCH_PRACTICE_PRODUCTS_WITHOUT_DETAILS_URL = "/practiceservice/getPracticeProductListWithoutDetails";
export const FETCH_ALL_PRODUCTS_URL = "/productservice/getProductList";
export const SAVE_PRACTICE_LOCATION_URL = "/practiceservice/practicelocation/save";
export const INACTIVE_PRACTICE_LOCATION_URL = "/practiceservice/practicelocation/inactivate";
export const SAVE_PRACTICE_PROVIDER_URL = "/practiceservice/practiceprovider/save";
export const INACTIVE_PRACTICE_PROVIDER_URL = "/practiceservice/practiceprovider/inactivate";
export const INACTIVE_AUTHORIZED_SIGNER_URL = "/practiceservice/inactivateAuthorizedSigners";
export const FETCH_PRACTICE_BILLER_URL = "/practiceservice/getPracticeBillerById";
export const UPDATE_PRACTICE_BILLER_URL = "/practiceservice/updatePracticeBillerById";
export const FETCH_PRACTICE_EXECUTIVE_URL = "/practiceservice/getPracticeExecutiveById";
export const UPDATE_PRACTICE_EXECUTIVE_URL = "/practiceservice/updatePracticeExecutiveById";
export const GET_PRACTICE_LOCATION_BY_LOCATIONID_URL = "/practiceservice/getPracticeLocationById";
export const FORGOT_PASSWORD_RESET_URL = "/authenticateservice/forgotPassword";
export const CHANGE_PASSWORD_RESET_URL = "/authenticateservice/changePassword";
// CS-518 Audit Log Api
export const SEARCH_AUDIT_LOGS_URL = "/auditlogservice/searchAuditLogs";
// patient related URL - START
export const CREATE_PATIENT_URL = "/patientservice/patient/savePatient";
export const FETCH_PATIENTLIST_URL = "/patientservice/getPatientList";
export const FETCH_PATIENT_URL = "/patientservice/patient";
export const GET_PATIENT_DETAILS_WITH_ACTIVE_PATIENT_INFO = "/patientservice/patientWithActivePatientInfo";
export const DELETE_PATIENT_URL = "patientservice/patient/deletePatient";
export const FETCH_PATIENT_LIST_BY_PRACTICE_ID = "patientservice/patient/byPractice";
export const CHECK_PATIENT_ELIGIBILITY = "patientservice/patient/checkPatientEligibility";
export const GET_PATIENT_LIST_BY_USER_ROLE = "/patientservice/patient/byUserRole";
export const GET_PATIENT_LIST_FOR_FILTER = "/patientservice/patient/getPatientListForFilter"; // CS-1300
export const SEARCH_PATIENT_LIST_URL = "/patientservice/patient/searchPatient";
export const CHECK_WOUND_INFO_HAS_IVR_URL = "/patientservice/patient/checkWoundInfoIvrAvailability";
export const CHECK_EXISTING_PATIENT_URL = "patientservice/patient/checkPatient";
export const SAVE_PATIENT_WOUND_INFO_REQUEST_URL = "/patientservice/patient/saveWoundInfo";
export const SAVE_PATIENT_BENEFICATION_SUMMARY_URL = "patientservice/patient/saveBenefitVerificationSummary"
export const GET_PATIENT_BENEFICATION_SUMMARY_URL = "patientservice/patient/getBenefitVerificationSummaryListByPatient"
export const GET_ACTIVE_PATIENT_BENEFICATION_SUMMARY_URL = "/patientservice/patient/getActiveBenefitVerificationSummaryListByPatient"
export const GET_ACTIVE_PATIENT_BENEFICATION_INSURANCE_SUMMARY_URL = "/patientservice/patient/getBenefitVerificationSummaryDetailById"
export const UPDATE_PATIENT_ADDRESS = "/patientservice/patient/updatePatientAddress"     // CS-1158 
export const INACTIVATE_PATIENT_WOUND_INFO_URL = "/patientservice/patient/inacivatePatientWoundInfo";
export const UPDATE_PATIENT_STATUS = "/patientservice/patient/changePatientStatus";
// patient related URL - END
//CS-1244 - Patient EMR related  URl
export const ADD_PATIENT_FROM_EMR = "/patientservice/patient/getPatientFromEmr"
export const GET_SURGICAL_TEMPLATE_BY_PROVIDER_ID = "/patientservice/patient/getSurgicalTemplateByProviderId"
//
export const GET_SURGICAL_TEMPLATE_BY_ID = "/patientservice/patient/getSurgicalTemplateByTemplateId"

export const GET_PRESCRIPTIONS_BY_PATIENT_ID = "/prescriptionservice/getPrescriptionsByPatientId"
export const GET_PRESCRIPTIONS_BY_PRODUCT_ID_AND_PATIENT_ID = "/prescriptionservice/getPrescriptionsByProductIdAndPatientId"

//cs-433
export const GET_APP_CONFIG_LIST_URL = "/commonservice/getAppConfigList";
export const EDIT_APP_CONFIG_URL = "/commonservice/appconfig/edit";
export const AUTOCOMPLETE_ADDRESS = "/commonservice/address_autocomplete"; // CS-1112
export const PLACE_DETAILS = "/commonservice/place_details"; // CS-1112
//
export const FETCH_MACS_URL = "/commonservice/getMacs";
export const FETCH_ALL_PAYERS = "/commonservice/getAllPayers";
export const FETCH_ACTIVE_AGENCY_EXECUTIVES_URL = "/commonservice/getActiveAgencyExecutives"
export const FETCH_PRODUCT_WITH_PRICE_URL = "/productservice/getProductsWithPricing"
export const SEARCH_PRACTICES_URL = "/practiceservice/searchPracticeList";
export const FETCH_BILLERS_URL = "/commonservice/getBillers";
export const GET_MANUFACTURERS_URL = "/commonservice/getManufacturers";
export const GET_PHARMACIES_URL = "/commonservice/getPharmacies"; // CS-2075
export const GET_MANUFACTURERS_URL_FOR_ANCILLARY_PRODCUT = "/commonservice/getManufacturersForAncillary";
export const GET_MANUFACTURER_LIST_BY_PRACTICE_URL = "/manufacturerService/getManufacturerListByPractice";
export const GET_MANUFACTURERS_BY_ROLE_FOR_COMMISSION_URL = "/manufacturerService/getManufacturerByRoleForCommission"; // CS-1765
export const GET_ALL_AGENCIES_URL = "/commonservice/getAllAgencies";
export const FETCH_PRODUCTS_PRICE_BY_MAC = "/productservice/getCurrentProductPricingByMAC";
export const REJECT_PRACTICE_REQUEST_URL = "/practiceservice/rejectPracticeRequest";
export const GET_DOCUMENT_URL = "/documentservice/getDocument";
export const GET_DOCUMENT_PUBLIC_URL = "/documentservice/getDocumentPublic";
export const GET_DOCUMENTS_URL = "/documentservice/getDocuments";
export const GET_TEMPLATE_BY_ID_URL = "/documentservice/getTemplate";
export const FETCH_DOCUMENT_HISTORY = '/documentservice/getDocumentHistory';
export const FETCH_PRACTICE_BY_USER_ROLE = "/practiceservice/getPracticesByUserRole";
export const FETCH_PRACTICE_LIST_FOR_FILTER = "/practiceservice/getPracticeListForFilter";
export const GET_PRACTICE_PRODUCT_BY_PRODUCTID = '/practiceservice/getPracticeProductById';
export const GET_PRODUCT_ITEM_BY_PRODUCT_ID = "/productservice/productitem/byProductId";
export const GET_PRODUCT_ITEMS_BY_PRODUCT_ID_FOR_ORDER_URL = "/productservice/productitem/byProductIdForOrder";
export const GET_PRODUCT_ITEM_BY_PRODUCT_ITEM_ID_URL = "/productservice/productitem/byProductItemId";
export const GET_PRODUCT_ITEM_BY_SKU_URL = "/productservice/productitem/bySKU";
export const GET_PRACTICE_PRODUCT_AGREEMENT_BY_PRACTICE_PRODUCT_URL = '/practiceservice/getPracticeProductAgreementById';
export const FETCH_UPDATED_PRACTICE_REGISTRATION_BY_PRACTICE_ID_URL = '/practiceservice/getPracticeProductListByPracticeAndProduct';
export const DOWNLOAD_UPDATED_REGISTRATION = "/practiceservice/downloadUpdatedRegistration";
export const GET_ALL_USER_PERMISSION_URL = "/tokennameservice/roleAdminTokenByUserId";
export const SAVE_USER_PERMISSION_TOKEN_URL = "/tokennameservice/saveUserPermissionTokens";
export const FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER = "/practiceservice/getPracticesByUserRoleforIvrorder";
export const GET_PRODUCT_ITEMS_IN_PROVIDER_TEMPLATE_BY_IVR_ID_URL = "/productservice/productitem/inProviderTemplateByIvrId";
export const GET_PRODUCT_ITEMS_IN_PROVIDER_TEMPLATE_BY_PATIENT_URL = "/productservice/productitem/inProviderTemplateBypatient";
export const FETCH_ORDER_BY_ID = "/orderservice/order";
export const GET_PRODUCTS_HAVE_AGREEGEMENTS_BY_PRACTICE_AND_CATEGORY_URL = "/productservice/practiceproduct/getAgreementsByPracticeAndProductCategory";
export const GET_AVAILABLE_DRUG_DOSAGE_BY_PRODUCT_URL = "/productservice/productitem/getAvailableDrugDosabeByProduct";

// product related URL - START
export const FETCH_PRODUCTLIST_URL = "/productservice/getProductList";
export const CREATE_PRODUCT_URL = "/productservice/saveProduct";
export const FETCH_PRODUCT_DETAILS = "/productservice/getProductDetails";
export const FETCH_PRODUCT_DETAILS_BY_ID = "/productservice/getProductById";
export const DELETE_PRODUCT_URL = "productservice/deleteProduct"
export const GET_PRODUCT_LIST_WITH_LOGO_URL = "productservice/getProductListWithLogo";
export const FETCH_PRODUCTS_BY_USER_ROLE_URL = "productservice/getProductsByUserRole";
export const SAVE_PRODUCT_LOGO_URL = "productservice/saveProductLogo";
export const GET_PRODUCT_DOCUMENTS_URL = "productdocumentsservice/getProductDocuments";
export const SEARCH_DOCUMENT_LIST_URL = "productdocumentsservice/searchProductDocumentList";
export const GET_DOCUMENT_CATEGORY_LIST_URL = "productdocumentsservice/getProductDocumentCategoryList";
export const FETCH_PRODUCTS_INCLUDING_INACTIVE_BY_USER_ROLE_URL = "productservice/getProductsByUserRoleIncludingInactive";
//CS-1564 - New api for product search
export const FETCH_ALL_PRODUCTS_BY_USER_ROLE_URL = "productservice/getAllProductsByUserRole";

// Explore Market
export const FETCH_EXPLORE_MARKET_PRODUCTS_URL = "exploremarketservice/getExploreMarketProducts";
export const REQUEST_EXPLORE_MARKET_PRODUCT_AGREEMENT_URL = "exploremarketservice/requestProductAgreement";
// CS-1731 - Explore market agreement request search
export const SEARCH_EXPLORE_MARKET_AGREEMENT_REQUESTS_URL = "exploremarketservice/searchAgreementRequests";
// CS-1747 - New agreement_request table endpoints
export const GET_REQUESTED_PRODUCT_IDS_URL = "exploremarketservice/getRequestedProductIds";
export const UPDATE_AGREEMENT_REQUEST_STATUS_URL = "exploremarketservice/updateAgreementRequestStatus";

export const SEARCH_PRODUCTLIST_URL = "/productservice/searchProductsList";
export const FETCH_PRODUCTS_INCLUDING_INACTIVE_FOR_PRODUCT_SEARCH_URL = "/productservice/getProductsIncludingInactiveForProductSearch";
export const AUTHENTICATE_EXTERNAL_LINK_URL = "productdocumentsservice/authenticateExternalLink";
export const PUBLISH_PRODUCT_DOCUMENT_URL = "productdocumentsservice/publishProductDocument";
export const GET_PRODUCT_DOCUMENT_BY_ID_URL = "productdocumentsservice/getProductDocumentById";
export const DELETE_PRODUCT_DOCUMENT_BY_ID_URL = "productdocumentsservice/deleteProductDocumentById";

export const SAVE_PRODUCT_ITEM_URL = "productservice/productitem/save";
//cs-551
export const SAVE_PRODUCT_PRICE_ITEM_URL = "productservice/productprice/saveProductPriceAndGenerateNewAgreements";
export const UPDATE_PRODUCT_TIER_PRICES_URL = "productservice/productprice/updateTierPrices";
// export const SAVE_PRODUCT_PRICE_ITEM_URL = "productservice/productprice/save";
//
export const INACTIVE_PRODUCT_PRICE_ITEM_URL = "productservice/productprice/inactivate";
export const DELETE_PRODUCT_PRICE_ITEM_URL = "productservice/productprice/delete";
export const INACTIVE_PRODUCT_ITEM_URL = "productservice/productitem/inactivate";
export const ACTIVE_PRODUCT_ITEM_URL = "productservice/productitem/activate";
export const GET_PRODUCT_ITEM_HISTORY_URL = "productservice/productitem/getProductItemsHistory";
export const GET_PRODUCT_PRICE_ITEM_HISTORY_URL = "productservice/productprice/getProductPricingHistory";
export const GET_PRODUCT_PRICING_BY_PRODUCT_ID_URL = "productservice/productprice/getProductPricingByProductId";
export const UPDATE_PRODUCT = "productservice/updateProduct";
export const UPLOAD_PRODUCT_DOCUMENT = "productdocumentsservice/uploadProductDocument";
export const INACTIVE_PRODUCT_DOCUMENT = "productdocumentsservice/inactivateProductDocument";
export const GET_INACTIVATED_PRODUCT_DOCUMENT = "productdocumentsservice/getInactiveProductDocument";
export const ACTIVATE_PRODUCT_DOCUMENT = "productdocumentsservice/activateProductDocument";
export const UPDATE_PRODUCT_DOCUMENT_STATUS = "productdocumentsservice/updateProductDocumentStatus";
// export const SAVE_PRODUCT_PRICE_ITEMS_URL = "productservice/productprice/saveItemPrices";
export const SAVE_PRODUCT_PRICE_ITEMS_URL = "productservice/productprice/saveProductPriceAndGenerateNewAgreements";

export const FETCH_PRODUCTS_AGREEMENTS = "/practiceservice/searchPracticeProductAgreementsList";
export const FETCH_SKU_PRODUCTS_AGREEMENTS_LIST = "/productservice/practiceproduct/getSKUProductAgreementsList";
export const CREATE_PRODUCT_AGREEMENT = "/productservice/practiceproduct/createProductAgreement";
export const PRACTICE_SIGN_PRODUCT_AGREEMENT = "/practiceservice/practiceSignProductAgreement";
export const MANUFACTURE_SIGN_PRODUCT_AGREEMENT = "/productservice/practiceproduct/manufacturerSignProductAgreement";
export const PREVIEW_PRACTICE_PRODUCT_AGREEMENT = "/productservice/practiceproduct/previewPracticeProductAgreement";
export const INITIATE_PRODUCT_AGREEMENT_URL = "/productservice/practiceproduct/initiateProductAgreements";
export const GET_AGREEMENT_COUNT_FOR_EXPIRED_PRODUCT_PRICE = "/productservice/practiceproduct/getAgreementCountForExpiredProductPrice";
export const GENERATE_NEW_AGREEMENTS_FOR_EXPIRED_PRODUCT_PRICE = "/productservice/practiceproduct/generateNewAgreementsForExpiredProductPrice";
export const UPLOAD_SIGNED_AGREEMENT_BY_ID = "/productservice/practiceproduct/uploadSignedAgreementById";
export const CHECK_ANCILLIARY_AGREEMENTS_BY_PRACTICE_ID_URL = "/productservice/practiceproduct/checkAncilliaryAgreementsByPractice";
export const CHECK_PRODUCT_AGREEMENTS_BY_PRODUCT_TYPE_BY_PRACTICE_ID_URL = "/productservice/practiceproduct/checkProductAgreementsByProductType";
export const GET_PRODUCT_QUESTIONS_BY_PRODUCT = "/productservice/getProductQuestionsByProduct";
export const GET_SAFEGUARD_QUESTIONS_BY_PRODUCT = "/productservice/getSafeguardQuestionsByProduct";

// CS-1760 START - Product Config Rule URLs
export const GET_PRODUCT_CONFIG_TEMPLATE_URL = "/productservice/getProductConfigTemplate";
export const GET_PRODUCT_CONFIG_BY_PRODUCT_URL = "/productservice/getProductConfigByProduct";
export const SAVE_PRODUCT_CONFIG_URL = "/productservice/saveProductConfig";
// CS-1760 END

// Product COGS / purchase price URLs
export const SAVE_PRODUCT_PURCHASE_PRICE_URL = "productservice/productpurchaseprice/save";
export const SAVE_PRODUCT_PURCHASE_PRICE_ITEMS_URL = "productservice/productpurchaseprice/saveItemPrices";
export const INACTIVE_PRODUCT_PURCHASE_PRICE_URL = "productservice/productpurchaseprice/inactivate";
export const DELETE_PRODUCT_PURCHASE_PRICE_URL = "productservice/productpurchaseprice/delete";
export const GET_PRODUCT_PURCHASE_PRICE_HISTORY_URL = "productservice/productpurchaseprice/getProductPurchasePricingHistory";
export const GET_ACTIVE_PRODUCT_PURCHASE_PRICES_URL = "productservice/productpurchaseprice/getActiveProductPurchasePricesByProductId";

// CS-1766 - Product Shipping Config URLs
export const GET_PRODUCT_SHIPPING_CONFIG_BY_PRODUCT_ID_URL = "/productservice/productShippingConfig/getProductShippingConfigByProductId";
export const SAVE_PRODUCT_SHIPPING_CONFIG_URL = "/productservice/productShippingConfig/save";
export const GET_PRODUCT_SHIPPING_CONFIG_FOR_ORDER_URL = "/productservice/productShippingConfig/getProductShippingConfigForOrder";
// CS-1766 END

// product related URL - END

export const FETCH_WOUNDCARE_INFO = "/codetableservice/getAllCodeTableValueByTableName";
export const DELETE_PRODUCT_AGREEMENT_BY_ID_URL = "/practiceservice/deleteProductAgreementById";
export const INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL = "/practiceservice/inactivateProductAgreementsById";
export const BULK_INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL = "/productservice/practiceproduct/bulkinactivateProductAgreementsById";
export const CREATE_MASS_PRODUCT_AGREEMENT_BY_ID_URL = "/productservice/practiceproduct/massCreateProductAgreements";

// user related URL - start
export const GET_ALL_USERROLES_URL = "userservice/userrole/list";
export const GET_USERPROFILE_BY_ID = "userservice/userprofile/get";
export const SAVE_USER_PROFILE_URL = "userservice/saveUserProfile";
export const SAVE_USER_PROFILE_PICTURE_URL = "userservice/saveUserProfilePicture";
export const SEARCH_USER_LIST_URL = "userservice/searchUserList";
export const RESET_PASSWORD_URL = "userservice/resetPassword";
export const INACTIVATE_ACTIVATE_USER_URL = "userservice/inactivateActivateUser";
//
export const SEARCH_NOTIFICATION_PREFERENCE_URL = "userservice/searchUserNotificationPreferenceList";
export const SAVE_NOTIFICATION_PREFERENCE_URL = "userservice/saveUserNotificationPreference";

export const SAVE_USER_PREFERENCE_URL = "userservice/saveUserPreference";
export const FETCH_USER_PREFERENCE_URL = "userservice/fetchUserPreferences";
export const FETCH_SECURITY_TOKENS_URL = "userservice/getSecurityTokens";
export const FETCH_USERS_BY_QUERY = "userservice/getUsersByQuery";
export const FETCH_USERS_BY_ROLE_IDS = "userservice/getUsersByUserRoleIds";
export const ADD_REMOVE_USER_PREFERENCE_VALUE_URL = "userservice/addRemovePreferenceValue";

export const GET_ALL_USERS = "userservice/getAllUsers";

// user related URL - end

// CS-1679 Start
export const GET_ACTIVE_USERS_DETAILS_LIST = "dashboardService/getActiveUsersKPIDetailsList";
export const GET_ACTIVE_PRACTICES_DETAILS_LIST = "dashboardService/getActivePracticesKPIDetailsList";
export const GET_WEEKLY_SALES_DETAILS_LIST = "dashboardService/getWeeklySalesPracticeWise";
// CS-1679 End

// IVR related URL - START
export const GET_ALL_IVR_URL = "/ivrservice/searchIvrList";
export const SAVE_IVR_URL = "/ivrservice/saveIvr";
export const SUBMIT_IVR_URL = "/ivrservice/submitIvr";
export const UPLOAD_IVR_DOCUMENT_URL = "/ivrservice/uploadIVRDocument";
export const REMOVE_IVR_DOCUMENT_URL = "/ivrservice/removeIVRDocument";
export const FETCH_IVR_BY_ID = "/ivrservice/ivr";
export const ADD_IVR_NOTE_URL = "/commonservice/note/add";
export const LIST_IVR_NOTES_URL = "/commonservice/note/list";
export const UPDATE_IVR_RESPOND = "/ivrservice/updateIVRRespond";
export const GET_IVR_DOCUMENTS_LIST_URL = "/ivrservice/getIVRDocumentsList";
export const DELETE_IVR_BY_ID = "/ivrservice/deleteIVRById";
export const CANCEL_IVR_BY_ID = "/ivrservice/cancelIVRById";
export const SEARCH_IVR_BY_PATIENT_NAME = "/ivrservice/searchIvrByPatientInfo";
export const SEARCH_IVR_BY_PATIENT_ID = "/ivrservice/searchIvrByPatientId";
export const UPDATE_PATIENT_DOCUMENT_INFO_URL = "/ivrservice/updatePatientInfo";
// IVR related URL - END

//ancillary related URL - START
export const CREATE_ORDER_ANCILLARY_ORDER = "/orderservice/order/addAncillary";
//
// Order related URL -START
export const CREATE_ORDER = "/orderservice/order/add";
export const CREATE_OUTSIDE_ORDER = "/orderservice/order/addOutsideOrder";
export const UPDATE_OUTSIDE_ORDER = "/orderservice/order/updateOutsideOrder";
export const GET_OUTSIDE_ORDER_DETAIL = "/orderservice/order/outsideOrderDetail";
export const UPDATE_ORDER = "/orderservice/order/update";
export const CANCEL_ORDER = "/orderservice/order/cancel";
export const REGISTER_WEBHOOK = "/orderservice/register17TrackWebhook";
export const GET_REALTIME_TRACKINFO = "/orderservice/getRealTimeTrackInfo";
//CS-1560
export const UPDATE_ORDER_ITEMS_PRICE = "/orderitemservice/updateOrderItems";
// CS - 922
export const PREVIEW_PPACKAGE_PDF = "/orderservice/order/previewPackaging";
//
// CS - 731 
export const PREVIEW_SALES_INVOICE_PDF = "/orderservice/order/previewSalesInvoice";
//
export const PREVIEW_PRESCRIPTION_PDF = "/orderservice/order/previewPrescription";
export const PREVIEW_CMS_1500_FORM = "/orderservice/order/previewCms1500Form";
export const PREVIEW_PROOFOFDELIVERY_PDF = "/orderservice/order/previewProofOfDelivery";
export const PREVIEW_EVALUATION_PDF = "/orderservice/order/previewEvaluationForm";
export const GET_ORDER_TRACKING_LOGS = "/orderservice/order/getOrderTrackingLogs";
export const VERIFY_ORDER_TRACKING_LOGS = "/orderservice/order/verifyOrderTrackingLogs";
//
export const GET_ORDER_ITEMS_BY_ID = "/orderitemservice/getOrderItemsByOrderId";
export const GET_ORDER_ITEMS_BY_INVOICE_ID_URL = "/orderitemservice/getOrderItemsByInvoiceId";
export const GET_ORDER_ITEMS_BY_CLAIM_ID_URL = "/orderitemservice/getOrderItemsByClaimId";
export const RETURN_ORDER = "/orderservice/order/producreturn/add";
export const APPROVE_PRODUCT_RETURN_URL = "/orderservice/order/producreturn/approve";
export const REJECT_PRODUCT_RETURN_URL = "/orderservice/order/producreturn/reject";
export const PENDING_PRODUCT_RETURN_URL = "/orderservice/order/producreturn/pending";
export const GET_PRODUCT_RETURN_AUDIT_URL = "/orderservice/order/producreturn";
export const SEARCH_ORDER = "/orderservice/order/search";
export const ADD_TISSUETRACKING_URL = "/orderservice/order/tissuetracking/add";
export const ADD_AGENCY_PRODUCT_COMMISSION_URL = "/orderservice/agencyproductcommission/add";
export const EDIT_AGENCY_PRODUCT_COMMISSION_URL = "/orderservice/agencyproductcommission/edit";
export const GET_ORDER_BY_PATIENT_ID = "/orderservice/getOrdersbyPatientId";
export const EDIT_AGENCY_PRODUCT_COMMISSION_BILLING_URL = "/orderservice/agencyproductcommission/editAgencyProductionCommissionRate"
//CS-1534 - Api endpoint for provider phase 2 change
export const GET_PLACE_ORDER_CHECK_API = "/orderservice/order/placeOrderCheck"
export const GET_SALES_DETAILS_BY_ID = "/salesimport/getSaleSheetDetailsByOrderId";
export const GET_SALES_DETAILS_BY_INVOICE_ID_URL = "/salesimport/getSaleSheetDetailsByInvoiceId";
export const ADD_COMMISSION_URL = "/commissionservice/commission/addCommission";
export const GET_COMMISSION_BY_PAYMENT_ID_URL = "/commissionservice/commission/getCommissionListByPaymentId";
export const UPDATE_COMMISSION_DATE_URL = "/commissionservice/commission/updateCommissionDate";
export const EDIT_COMMISSION_RATE_URL = "/commissionservice/commission/editCommissionRate";
export const GET_COMMISSION_PROFIT_DETAIL_BY_INVOICE_ID_URL = "/commissionservice/commission/getCommissionProfitDetailByInvoiceId";
export const UPDATE_COMMISSION_PROFIT_COSTS_URL = "/commissionservice/commission/updateCommissionProfitCosts";
export const GET_SALES_GOAL_LIST_URL = "/commissionservice/salesGoal/getSalesGoalList";
export const SAVE_SALES_GOAL_URL = "/commissionservice/salesGoal/saveSalesGoal";
export const UPDATE_SALES_GOAL_URL = "/commissionservice/salesGoal/updateSalesGoal";
export const GET_SALES_CONFIG_LIST_URL = "/commissionservice/salesConfig/getSalesConfigList";
export const SAVE_SALES_CONFIG_URL = "/commissionservice/salesConfig/saveSalesConfig";
export const UPDATE_SALES_CONFIG_URL = "/commissionservice/salesConfig/updateSalesConfig";

// Order related URL -START

// Claim related URL -START
export const SUBMIT_CLAIM_URL = "/claimservice/claim/add";
export const REIMBURSE_CLAIM_URL = "/claimservice/claim/reimburse";
export const MARK_CLAIM_AS_READY_URL = "/claimservice/claim/markAsReady";
export const MARK_AS_CLAIMED_URL = "/claimservice/claim/markAsClaimed";
export const GET_CLAIM_BY_ID_URL = "/claimservice/claim/getById";
export const GET_CLAIM_LIST = "/claimservice/claim/search";
export const RECORD_CLAIM_PAYMENT = "/claimservice/claim/addPayment";
export const UPDATE_CLAIM_STATUS = "/claimservice/claim/updateStatus";
export const UPLOAD_CLAIM_DOCUMENT_URL = "/claimservice/claim/uploadDocument";
// Claim related URL -END

// Agency related URL -START
export const SAVE_AGENCY_URL = "/agencyservice/add";
export const EDIT_AGENCY_URL = "/agencyservice/agency/edit";
export const EDIT_PRODUCT_COMMISSIONS_URL = "/agencyservice/agency/edit";
export const GET_AGENCY_LIST_URL = "/agencyservice/searchAgencyList";
//CS-431
export const GET_AGENCY_INFO_WITH_PRODUCT_USER_AND_COMMISSION_URL = "/agencyservice/getAgencyInfoWithProductUserAndCommission";
export const INACTIVATE_AGENCY = "/agencyservice/inactivate";
//
export const GET_AGENCY_BY_ID_URL = "/agencyservice/getAgencyById";
export const GET_ASSOCIATE_AGENCY_LIST_URL = "/agencyservice/getAssociateAgencyList";
export const GET_PRODUCT_COMMISSIONS_BY_AGENCY_ID_URL = "/agencyservice/listAgencyCommission";
export const GET_IS_V3_AGENCY_EXISTS_URL = "/agencyservice/isV3AgencyExists";
export const GET_AGENCY_BY_USER_URL = "/agencyservice/getAgencyByUser";
//CS-1191 - Start
export const GET_ACTIVE_OVERRIDE_AGENCY_LIST_URL = "/agencyservice/getAllOverrideAgency";
export const GET_ISR_AGENCY_LIST_URL = "/agencyservice/getIsrAgencyList";
export const GET_ISR_USER_EMAIL_LIST_URL = "/agencyservice/getIsrUserEmailList";
export const GET_ISR_USER_DETAILS_URL = "/agencyservice/getIsrUserDetails";
// CS-1191 - End
//CS-1234 - Start
export const GET_OVERRIDE_AGENCY_BY_PRACTICE_ID = "/agencyservice/getOverrideAgencyCommissionsByPracticeId";
// CS-1234 - End
// Agency related URL -START

//Two Factor related URL - START
export const INACTIVATE_TWO_FACTOR_OPTION = "userservice/user/2fa/inactivate";
export const SAVE_TWO_FACTOR_COMMUNICATION_DETAIL = "userservice/user/2fa/add";
export const SEND_OTP = "userservice/user/2fa/generate2facode";
export const TWO_FACTOR_COMMUNICATION_DETAILS = "userservice/user/2fa/list";
export const VALIDATE_OTP = "userservice/user/2fa/validate2facode";
export const VALIDATE_OTP_NON_LOGGEDIN_USERS = "userservice/user/2fa/validate2facodeForNonLoggedInUsers";
export const GET_ALL_USER2FA_LIST = "userservice/user/2fa/list";
export const UPDATE_TWO_FACTOR_COMMUNICATION_DETAIL = "userservice/user/2fa/update";
//Two Factor related URL - END

// Invoice Related URL - START
export const SEARCH_INVOICE_URL = "/invoiceservice/invoice/searchInvoiceList";
export const ADD_INVOICE_URL = "/invoiceservice/invoice/addInvoice";
//CS-1322  - start
export const CREATE_INVOICE_URL = "/invoiceservice/invoice/createInvoice";
export const PREVIEW_INVOICE_URL = "/invoiceservice/previewInvoice";
//CS-1322  - end
export const GET_INVOICE_BY_ID_URL = "/invoiceservice/invoice";
//CS-1191 - start
export const GET_APPLY_INVOICE_DETAIL_URL = "/invoiceservice/invoice/getApplyInvoiceDetail";
export const GET_EDIT_INVOICE_DETAIL_URL = "/invoiceservice/invoice/getInvoiceDetails"
export const DELETE_INVOICE_AGENCY_URL = "/invoiceservice/invoice/deleteInvoiceAgency"
// CS-1191 - end

// CS-1583 - START
export const ADD_LATE_FEE = "/invoiceservice/invoice/addLateFee";
export const GET_LATE_FEE_HISTORY_URL = "/invoiceservice/invoice/getLateFeeHistoryByInvoice";
// CS-1583 - END

// CS-1666 - START
export const SHARE_INVOICES_URL = "/invoiceservice/invoice/shareInvoices";
export const SEARCH_SHARE_INVOICE_URL = "/invoiceservice/invoice/searchShareInvoiceList";
// CS-1666 - END
export const GET_INVOICE_LIST_BY_PRACTICE = "/invoiceservice/invoice/getInvoicesByPractice";
// CS-1995 - products with open (PARTIAL/UNPAID) invoices for a practice (bulk payment product dropdown)
export const GET_PRODUCTS_WITH_OPEN_INVOICES_BY_PRACTICE_URL = "/invoiceservice/invoice/getProductsWithOpenInvoicesByPractice";
export const GET_INVOICES_BY_MANUFACTURER_AND_PRACTICE_URL = "/invoiceservice/getInvoicesByManufacturerAndPractice" // CS - 1216

// task cs-647 start
export const EDIT_INVOICE_URL = "/invoiceservice/invoice/editInvoice";
// task cs-647 end
export const UPLOAD_INVOICE_URL = "/invoiceservice/invoice/uploadInvoice";
export const GET_CREDIT_MEMO_DETAIL_BY_INVOICE_ID = "/invoiceservice/getDetailForCreateCreditMemoByInvoiceId"
export const ADD_CREDIT_MEMO = "/invoiceservice/invoice/addCreditMemo"
export const ADD_PAYMENTS_URL = "/paymentservice/payment/addPayments"
export const ADD_INVOICE_NOTE_URL = "/commonservice/note/add"; //CS-1212
export const LIST_INVOICE_NOTES_URL = "/commonservice/note/list"; //CS-1212
export const SEARCH_PAYMENTS_URL = "/paymentservice/payment/searchPayments"
export const RECORD_MULTIPLE_PAYMENTS_URL = "/paymentservice/payment/recordMultiplePayments" // CS - 1216
export const GET_INVOICE_AGENCY_URL = "/invoiceservice/invoice/getInvoiceAgency"; // CS - 1384

export const ADD_PAYMENT_NOTE_URL = "/commonservice/note/add"; //CS-1212
export const LIST_PAYMENT_NOTES_URL = "/commonservice/note/list"; //CS-1212
export const VOID_PAYMENT_URL = "/paymentservice/payment/voidPayment";
export const GET_PAYMENT_BY_ID_URL = "/paymentservice/payment/getPaymentById";
export const GET_PAYMENTS_BY_INVOICE_ID_URL = "/paymentservice/payment/getPaymentsByInvoiceId";

export const UPDATE_INVOICE_STATUS_URL = "/invoiceservice/invoice/updateInvoice"; // CS-1532
// Invoice Related URL - END

// Payment Related URL - START
export const UPLOAD_PAYMENT_URL = "/paymentservice/payment/uploadPayments";
export const UPLOAD_COMMISSION_PAYMENT_URL = "/commissionservice/commission/uploadCommissionPayments";
export const SAVE_COMMISSION_PAYOUTS_URL = "/commissionservice/commission/saveCommission";
export const SAVE_MULTIPLE_COMMISSION_PAYOUTS_URL = "/commissionservice/commission/saveMultipleCommissions";
// Payment Related URL - END

// WoundCode Related URL - START
export const GET_ALL_WOUND_CODE = "/woundcodeservice/getAllWoundCodes";
export const GET_WOUND_CODE_BY_QUERY = "/woundcodeservice/getWoundCodesByQuery";
export const GET_WOUND_BY_WOUND_KEY = "/woundcodeservice/getWoundsByWoundKey";
// WoundCode Related URL - END

// BAA Related URL - START
export const SEARCH_BAA_LIST_URL = "/baaService/seachBaaDetail";
export const SIGN_BAA_DETAIL_URL = "/baaService/signBaaDetail";
export const PREVIEW_BAA_DETAIL_URL = "/baaService/previewBaaDetail";
export const UPLOAD_BAA_DETAIL_URL = "/baaService/uploadBaaDetail";
// BAA Related URL - END

// Manufacturer Notification Related URL - START
export const VALIDATE_CREDENTAILS_URL = "/manufacturerNotificationService/validateManufacturerCredentails";
export const DOWNLOAD_DOCUMENT_URL = "/manufacturerNotificationService/downloadDocument";
export const VALIDATE_MANUFACTURER_LINK = "/manufacturerNotificationService/validateManufacturerEmail";
// Manufacturer Notification Related URL - END

//Manufacturer Related URL - START
export const GET_MANUFACTURER_LIST_URL = '/manufacturerService/getManufacturerList';
export const SAVE_MANUFACTURER_URL = '/manufacturerService/manufacturer/add';
export const EDIT_MANUFACTURER_URL = '/manufacturerService/manufacturer/edit';
export const GET_MANUFACTURER_DATA_BY_ID = '/manufacturerService/getManufacturer'

//CS-1625
export const GET_MANUFACTURERS_BY_ROLE_URL = "/manufacturerService/getManufacturerByRole";
//Manufacturer Related URL - END

//Provider Related URL - START
export const FETCH_PRACTICE_PROVIDERS_LIST_URL = "/practiceservice/practiceprovider/getPracticeProvidersList";
export const FETCH_PRACTICE_PROVIDER_BY_USER_ID_URL = "/practiceservice/practiceprovider/getPracticeProviderByUserId";
export const FETCH_ALL_USED_PROVIDER_IDS_URL = "/practiceservice/practiceprovider/getAllUsedProviderIDs";
export const GET_IS_LAST_PROVIDER_BY_USER_ID_URL = "/practiceservice/practiceprovider/getIsLastProviderByUserId";
export const GET_PROVIDER_TEMPLATES_BY_PROVIDERID_URL = "/practiceservice/practiceprovider/getProviderTemplatesByProviderId";
export const SEARCH_PROVIDER_URL = "/practiceservice/practiceprovider/seachProvider"
export const FETCH_ALL_PROVIDERS = "/practiceservice/practiceprovider/getAllPracticeProviders";
export const FETCH_ACTIVE_PRACTICE_LOCATIONS_FOR_GIVEN_DATE = "/practiceservice/practicelocation/getActivePracticeLocationsForGivenDate"

//CS-1302 - Start Provider notification related URL
export const GET_ORDER_DETAILS_IN_PROVIDERNOTIFICATION = "/providerNotificationService/getOrderDetailsByOrderId";
export const SAVE_PROVIDER_SIGN_FOR_ORDER = "/providerNotificationService/signOrderWithProviderSignature"

//CS-1302 - End
//Provider Related URL - END

//Collagen Realated URL-START

export const FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_ID = 'kitservice/getProductItemKitItemByProductItemId';
export const FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_IDS = 'kitservice/getProductItemKitItemByProductItemIds';
export const SAVE_PRODUCT_KIT_URL = '/kitservice/kit/saveProductItemKitItem';
export const DELETE_KIT_ITEM_PRODUCT_BY_ID_URL = "/kitservice/deleteKitItemProductByproductKitItemId";
//Collagen Realated URL-END

//Prescription Realated URL-START
export const SUBMIT_PRESCRIPTION_URL = 'prescriptionservice/submitPrescription';
export const SEARCH_PRESCRIPTIONS_URL = '/prescriptionservice/searchPrescriptions';
export const GET_RX_REQUIRED_OPEN_ACCESS_PRODUCTS_URL = '/productservice/getRxRequiredOpenAccessProducts';
export const SEND_NOTIFICATION_EMAIL_URL = '/prescriptionservice/sendNotificationEmail';
// CS-2073 - pharmacy_licenses for state-based Rx gating
export const GET_PHARMACY_LICENSES_BY_PHARMACY_ID_URL = '/prescriptionservice/getPharmacyLicensesByPharmacyId';
// CS-2073 - compliance audit for Gate 1 blocked ship-to attempts
export const LOG_RX_GATING_BLOCKED_ATTEMPT_URL = '/prescriptionservice/logRxGatingBlockedAttempt';
// CS-2073 - compliance audit for Gate 2 prescriber confirmation
export const LOG_PRESCRIBER_CONFIRMATION_URL = '/prescriptionservice/logPrescriberConfirmation';
// CS-2075 - live Genesis AutoPilotRx intake record for Response JSON
export const GET_GENESIS_INTAKE_RECORD_URL = '/prescriptionservice/getGenesisIntakeRecord';
// CS-2075 - fills the Genesis credit card authorization template for the Fill Up preview
export const PREVIEW_GENESIS_CARD_AUTHORIZATION_URL = '/prescriptionservice/previewGenesisCardAuthorization';
export const GET_RX_AGREEMENT_PRACTICE_LOOKUP_URL = '/prescriptionservice/getRxAgreementPracticeLookup';
//Prescription Realated URL-END


//Notification Realated URL-START
export const GET_NOTIFICATION_LIST = "/notificationservice/getAllNotifications";
export const SAVE_USER_SENT_NOTIFICATION = "/notificationservice/saveNotification";
export const ACK_NOTIFICATION = "/notificationservice/acknowledgeNotification";
export const ACK_ALL_NOTIFICATIONS = "/notificationservice/acknowledgeAllNotifications"
export const GET_NOTIFS_BY_REF_ENTITIES = "/notificationservice/getNotificationsByRefEntity";
export const GET_ALERT_ENTITITY_NUMBERS = "/notificationservice/getAlertedRecordsOfEntity";
export const ASSIGN_NOTIFICATION = "/notificationservice/assignNotification";
export const GET_IMPORTANT_UNREAD_NOTIFICATIONS = "/notificationservice/importantUnreadNotifications";
export const DELETE_NOTIFICATION_BY_ID = "/notificationservice/deleteNotification";
export const DELETE_ALL_NOTIFICATIONS = "/notificationservice/deleteAllNotifications";
export const GET_ALL_SENT_MESSAGES = "/notificationservice/getAllSentMessages";
export const UPLOAD_NOTIFICATION_DOCUMENT_URL = "/notificationservice/uploadNotificationDocument";
export const REMOVE_NOTIFICATION_DOCUMENTS_URL = "/notificationservice/removeNotificationDocument";

export const WS_NOTIFICATION = "/ws"

export const STRIPE_PAYMENT_EXPIRE_SESSION_URL = "/stripepaymentservice/expire-session";
export const STRIPE_PAYMENT_CHECKOUT_URL = "/stripepaymentservice/create-checkout-session";
export const STRIPE_UPFRONT_ORDER_CHECKOUT_URL = "/stripepaymentservice/create-upfront-order-checkout"; // CS-1845
// CS-1750 - Start
export const STRIPE_OAUTH_CONNECT_URL = "/stripepaymentservice/oauth/connect";
// CS-1750 - End

//CS-1682 - Bulk Payment Related URL - START
export const BULK_PAYMENT_CHECKOUT_URL = "/stripepaymentservice/create-checkout-session";
//Notification Realated URL-END

//Dashboard Related URL - START
export const FETCH_ACTIVE_USERS_DATA = "/dashboardService/getActiveUsersKPIData";
export const FETCH_ACTIVE_USERS_DATA_DATE_RANGE = "/dashboardService/getActiveUsersKPIDataDateRange";
export const FETCH_ACTIVE_PRACTICE_DATA = "/dashboardService/getActivePracticesKPIData";
export const FETCH_ACTIVE_PRACTICE_DATA_DATE_RANGE = "/dashboardService/getActivePracticesKPIDataDateRange";
export const FETCH_TOTAL_PATIENTS_DATA = "/dashboardService/getTotalPatientsKPIData";
export const FETCH_WEEKLY_SALES_DATA = "/dashboardService/getWeeklySalesKPIData";
export const FETCH_WEEKLY_ORDERS_DATA = "/dashboardService/getWeeklyOrdersKPIData";
export const FETCH_ORDER_BREAKDOWN_DATA = "/dashboardService/getOrderBreakdownData";
export const FETCH_IVR_BREAKDOWN_DATA = "/dashboardService/getIvrBreakdownData";
export const FETCH_MONTHLY_ORDERS_TWELVE_MONTH_DATA = "/dashboardService/getMonthlyOrderCountsTwelveMonths";
export const FETCH_MONTHLY_IVR_TWELVE_MONTH_DATA = "/dashboardService/getMonthlyIvrCountsTwelveMonths";
export const FETCH_WEEKLY_RECORD_TX_DATA = "/dashboardService/getWeeklyRecordTxPercentage";
export const FETCH_TOTAL_PATIENTS_DATA_DATE_RANGE = "/dashboardService/getTotalPatientsKPIDataDateRange";
export const FETCH_WEEKLY_SALES_DATA_DATE_RANGE = "/dashboardService/getWeeklySalesKPIDataDateRange";
export const FETCH_WEEKLY_ORDERS_DATA_DATE_RANGE = "/dashboardService/getWeeklyOrdersKPIDataDateRange";
export const FETCH_ORDER_BREAKDOWN_DATA_DATE_RANGE = "/dashboardService/getOrderBreakdownDataDateRange";
export const FETCH_IVR_BREAKDOWN_DATA_DATE_RANGE = "/dashboardService/getIvrBreakdownDataDateRange";
export const FETCH_WEEKLY_RECORD_TX_DATA_DATE_RANGE = "/dashboardService/getWeeklyRecordTxPercentageDateRange";

//Dashboard Related URL - END

//CS-1401 START
export const FETCH_ALL_JOBS_URL = "/jobservice/jobs/list"
export const SCHEDULE_JOB_URL = "/jobservice/jobs/schedule"
export const UNSCHEDULE_JOB_URL = "/jobservice/jobs/unschedule"
export const RUN_JOB_URL = "/jobservice/jobs/run"
export const EDIT_JOB_URL = "/jobservice/jobs/edit"
export const CHANGE_JOB_STATUS_URL = "/jobservice/jobs/changestatus"
export const CHANGE_JOB_SCHEDULE_STATUS_URL = "/jobservice/jobs/changeschedulestatus"
//CS-1401 END

//CS-1595 
//CS-1595 - Medical Note Audit API
export const MEDICAL_NOTE_AUDIT_BASE_URL = "http://107.20.93.119:8006";
export const UPLOAD_AUDIT_PDF_URL = "/commonservice/uploadMedicalAuditNoteAI";
// export const UPLOAD_AUDIT_PDF_URL = "/api/audit/upload";
export const GET_AUDIT_REPORT_URL = "/commonservice/getMedicalAuditNoteAI";
// export const GET_AUDIT_REPORT_URL = "/api/audit";
//CS-1594  && CS-1706
export const GET_SERVICE_AGREEMENT_URL = "/servicesubscription/getServiceAgreement";
export const SIGN_SERVICE_SUBSCRIPTION_URL = "/servicesubscription/signServiceSubscription";
export const PREVIEW_SERVICE_AGREEMENT_URL = "/servicesubscription/previewServiceAgreement";
export const SEARCH_AI_AUDIT_DATA_LIST_URL = "/aiauditservice/searchAuditDataList";
export const GET_PATIENT_AI_AUDIT_DATA_URL = "/aiauditservice/patient";
export const GET_RECENT_AI_AUDIT_DETAILS_BY_ID_URL = "/aiauditservice/getRecentAuditDetail";
export const GET_ALL_AUDIT_DETAILS_BY_ID_URL = "/aiauditservice/getAllAuditDetails"
export const GET_AI_AUDIT_DETAIL_BY_ID_URL = "/aiauditservice/getAuditDetailsById";
export const SEARCH_SERVICE_SUBSCRIPTION_URL = "/servicesubscription/searchServiceSubscription";
export const GET_ACTIVE_SERVICES_URL = "/servicesubscription/getActiveServices";

// CS-1758 - Facesheet Extraction API
export const EXTRACT_FACESHEET_AI_URL = "/commonservice/extractFacesheetAI";

// CS-1773 - Run Medical Note Audit AI Tool in Background
export const SEARCH_AI_AUDIT_DATA_URL = "/aiauditservice/searchAiAuditData";

// CS-2018 - EC2 server-control dashboard (Super Admin)
export const EC2_LIST_URL = "/ec2service/list";
export const EC2_START_URL = "/ec2service/start";
export const EC2_STOP_URL = "/ec2service/stop";
export const EC2_AUDIT_LOGS_URL = "/ec2service/auditLogs";